import React from "react";
import { Dialog, useTheme } from "@material-ui/core";
import { useSelector } from "react-redux";
import { isFirefox } from "react-device-detect";

const EMPTY_FUNC = () => {};
const DialogContext = React.createContext([EMPTY_FUNC, EMPTY_FUNC]);
export const useDialog = () => React.useContext(DialogContext);

function DialogContainer(props) {
  const { children, open, onClose, onKill } = props;
  const darkMode = useSelector((state) => state.trading.DARK_MODE);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      onExited={onKill}
      PaperProps={{
        style: {
          ...(!isFirefox && {
            background: darkMode
              ? "rgba(255, 255, 255, 0.1)"
              : "rgba(0, 0, 0, 0.3)",
            backdropFilter: darkMode ? "blur(20px)" : "blur(10px)",
            WebkitBackdropFilter: darkMode ? "blur(20px)" : "blur(10px)",
            borderRadius: "16px",
          }),
        },
      }}
    >
      {children}
    </Dialog>
  );
}
//  background: darkMode
//           ? "rgba(255, 255, 255, 0.1)"
//           : "radial-gradient(98.09% 98.09% at 31.51% 23.05%, rgba(255, 255, 255, 0.5)  100%, rgba(255, 255, 255, 0.5) 100%)",
//         color: darkMode ? "#fff" : "#000",
//         backdropFilter: darkMode ? "blur(20px)" : "blur(10px)",
//         WebkitBackdropFilter: darkMode ? "blur(20px)" : "blur(10px)",
//         borderRadius: "16px",
export default function DialogProvider({ children }) {
  const [dialogs, setDialogs] = React.useState([]);
  const createDialog = (option) => {
    const dialog = { ...option, open: true };
    setDialogs((dialogs) => [...dialogs, dialog]);
  };
  const closeDialog = () => {
    setDialogs((dialogs) => {
      const latestDialog = dialogs.pop();
      if (!latestDialog) return dialogs;
      if (latestDialog.onClose) latestDialog.onClose();
      return [...dialogs].concat({ ...latestDialog, open: false });
    });
  };
  const contextValue = React.useRef([createDialog, closeDialog]);

  return (
    <DialogContext.Provider value={contextValue.current}>
      {children}
      {dialogs.map((dialog, i) => {
        const { onClose, ...dialogParams } = dialog;
        const handleKill = () => {
          if (dialog.onExited) dialog.onExited();
          setDialogs((dialogs) => dialogs.slice(0, dialogs.length - 1));
        };

        return (
          <DialogContainer
            key={i}
            onClose={closeDialog}
            onKill={handleKill}
            {...dialogParams}
          />
        );
      })}
    </DialogContext.Provider>
  );
}
